import React, { useMemo } from "react";

import CircleIcon from "@mui/icons-material/Circle";
import CircleOutlinedIcon from "@mui/icons-material/CircleOutlined";
import HourglassTopIcon from "@mui/icons-material/HourglassTop";

import { EnumValue } from "@fartherfinance/frontend/api/TaskWorkflows/Types";

import HalfFilledCircleIcon from "@src/assets/svg/halfFilledCircle";
import { toClassName } from "@src/multiCustodian/utils/to-class-name";

import styles from "./TaskStatusIcon.module.css";

interface TaskStatusIconProps {
  className?: string;
  taskStatus: EnumValue["id"];
}

const TaskStatusIcon: React.FC<TaskStatusIconProps> = ({
  className,
  taskStatus,
}) => {
  const Icon = useMemo(() => {
    if (taskStatus.startsWith("WAITING_ON")) {
      return HourglassTopIcon;
    }

    if (taskStatus === "IN_PROGRESS") {
      return HalfFilledCircleIcon;
    }

    if (taskStatus === "COMPLETED" || taskStatus === "CANCELED") {
      return CircleIcon;
    }

    return CircleOutlinedIcon;
  }, [taskStatus]);

  return (
    <Icon
      className={toClassName(className, styles.icon, {
        [styles.notStarted]: taskStatus === "NOT_STARTED",
        [styles.inProgress]: taskStatus === "IN_PROGRESS",
        [styles.waitingOn]: taskStatus.startsWith("WAITING_ON"),
        [styles.completed]: taskStatus === "COMPLETED",
        [styles.canceled]: taskStatus === "CANCELED",
      })}
    />
  );
};

export default TaskStatusIcon;
